<template>
  <app-layout>
    <app-layout-header>
      <app-card primary no-padding border-radius="0">
        <app-list-item>
          <app-image class="logo" src="images/logo.svg" />
        </app-list-item>

        <app-list-item @click="app.goToScreen({ name: 'userProfileEdit' })">
          <app-image
            avatar
            square
            :src="getUserAvatarImage(app.user).thumbnail"
          />

          <app-list-item-content>
            <h3
              v-text="app.getFirstWord(app.user.fullName)"
              style="margin-bottom: 0.5rem"
            ></h3>
            <small>Editar perfil</small>
          </app-list-item-content>

          <app-button
            transparent
            icon
            @click.native="app.closeUserSidebar"
            style="margin-left: auto"
          >
            <app-icon>keyboard_arrow_right</app-icon>
          </app-button>
        </app-list-item>
      </app-card>
    </app-layout-header>

    <app-layout-content class="negative-top-margin">
      <app-card border-bottom-radius="0" padding="0">
        <app-list>
          <app-list-item @click.native="app.goToScreen({ name: 'userOrders' })">
            <app-icon>shopping_cart</app-icon>
            <app-list-item-content> Meus Pedidos </app-list-item-content>
          </app-list-item>

          <!-- <app-list-item
            @click.native="app.goToScreen({ name: 'userNotifications' })"
            :class="{ active: $route.name === 'userNotifications' }"
          >
            <app-icon>notifications</app-icon>
            <span>Notificações</span>
            <span
              v-if="notifications.unread > 0"
              class="badge badge-red badge-small"
              style="
                background-color: var(--primary-color);
                position: absolute;
                left: 30px;
                top: 0;
              "
              v-text="notifications.unread"
            ></span>
          </app-list-item> -->

          <app-list-item
            @click.native="app.goToScreen({ name: 'userCashback' })"
            :class="{ active: $route.name === 'userCashback' }"
          >
            <app-icon>assessment</app-icon>
            <span>Meu Cashback</span>
          </app-list-item>

          <app-list-item
            @click.native="app.goToScreen({ name: 'userAffiliates' })"
            :class="{ active: $route.name === 'userAffiliates' }"
          >
            <app-icon>device_hub</app-icon>
            <span>Afiliados</span>
          </app-list-item>

          <app-list-item
            @click.native="app.goToScreen({ name: 'userSettings' })"
            :class="{ active: $route.name === 'userSettings' }"
          >
            <app-icon>settings</app-icon>
            <span>Configurações</span>
          </app-list-item>

          <app-list-item
            @click.native="app.goToContact"
            :class="{ active: $route.name === 'contact' }"
          >
            <app-icon>mail_outline</app-icon>
            <span>Contato</span>
          </app-list-item>

          <app-list-item
            v-if="isDeliveryMan"
            @click.native="app.goToScreen({ name: 'userMakeDelivery' })"
          >
            <app-icon>receipt</app-icon>
            <span>Fazer uma entrega</span>
          </app-list-item>

          <app-list-item
            v-if="app.showRetrospective"
            @click.native="app.goToRetrospective()"
          >
            <app-icon>emoji_events</app-icon>
            <span>Retrospectiva</span>
          </app-list-item>

          <app-list-item @click.native="logout">
            <app-icon>exit_to_app</app-icon>
            <span>Sair</span>
          </app-list-item>
        </app-list>
      </app-card>
    </app-layout-content>
  </app-layout>
</template>

<script>
import { USER_TYPE_DELIVERYMAN } from '@/constants'

export default {
  name: 'UserSidebar',

  data() {
    return {
      notifications: {
        timer: undefined,
        checkInterval: 5,
        unread: 0,
      },
    }
  },

  props: {
    active: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    isDeliveryMan() {
      const userTypes = app.user?.types ?? []

      return userTypes.includes(USER_TYPE_DELIVERYMAN)
    },
  },

  destroyed() {
    this.stopUnreadNotifications()
  },

  methods: {
    getUserAvatarImage(user) {
      return (
        user?.avatar ??
        user?.facebook?.image ?? {
          thumbnail: 'images/user.jpg',
        }
      )
    },

    startUnreadNotifications(runImmediately = true) {
      this.stopUnreadNotifications()

      if (runImmediately === true) this.loadTotalUnreadNotifications()

      this.notifications.timer = window.setTimeout(
        () =>
          this.loadTotalUnreadNotifications().finally(() =>
            this.startUnreadNotifications(false),
          ),
        this.notifications.checkInterval * 1000,
      )

      return this
    },

    stopUnreadNotifications() {
      const notifications = this.notifications

      window.clearTimeout(notifications.timer)
      notifications.timer = null

      return this
    },

    async loadTotalUnreadNotifications() {
      const response = await app.callApi({
        action: `notifications`,
        query: {
          userId: app.user.id,
          visualizedIn: null,
          limit: 1,
        },
      })

      this.notifications.unread = response.total

      return this
    },

    logout() {
      app.confirm({
        content: 'Você tem certeza que deseja sair?',
        onOk: async () => {
          await Promise.all([app.logout(), this.stopUnreadNotifications()])

          app.goToScreen('/')
        },
      })

      return this
    },
  },
}
</script>

<style lang="scss" scoped>
.logo {
  height: 56px;
}
</style>
